import React, { useEffect, useRef } from 'react';
interface SearchBarProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
}
export function SearchBar({
  searchTerm,
  setSearchTerm
}: SearchBarProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.ctrlKey && e.key === 'f') {
        e.preventDefault();
        inputRef.current?.focus();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);
  return <div className="my-8 text-center" data-id="element-669">
      <input ref={inputRef} type="text" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} placeholder="🔍 Search protocols, conditions, points, patterns, or any keyword..." className="w-full max-w-2xl px-6 py-4 text-base border-2 border-gray-300 rounded-full outline-none transition-all duration-300 shadow-lg focus:border-purple-600 focus:shadow-purple-300" data-id="element-670" />
    </div>;
}